module.exports = __webpack_public_path__ + "img/shrimp-frozen.d0c25e1c.png";